var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "master_svg0_8_05683"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 18,
    height: 18,
    rx: 0
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#master_svg0_8_05683)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M9,16.5C4.8578600000000005,16.5,1.5,13.1421,1.5,9C1.5,4.8578600000000005,4.8578600000000005,1.5,9,1.5C13.1421,1.5,16.5,4.8578600000000005,16.5,9C16.5,13.1421,13.1421,16.5,9,16.5ZM9,15C12.3137,15,15,12.3137,15,9C15,5.68629,12.3137,3,9,3C5.68629,3,3,5.68629,3,9C3,12.3137,5.68629,15,9,15ZM8.25,11.25L9.75,11.25L9.75,12.75L8.25,12.75L8.25,11.25ZM9.75,10.01632L9.75,10.5L8.25,10.5L8.25,9.375C8.25,8.96077,8.58577,8.625,9,8.625C9.6213,8.625,10.125,8.1213,10.125,7.5C10.125,6.87868,9.6213,6.375,9,6.375C8.45422,6.375,7.9992,6.76367,7.8966,7.27933L6.42548,6.9851C6.66478,5.78189,7.7265,4.875,9,4.875C10.44975,4.875,11.625,6.05025,11.625,7.5C11.625,8.689129999999999,10.83427,9.6936,9.75,10.01632Z",
    fill: "#A6A6A6",
    fillOpacity: 1,
    style: {
      mixBlendMode: "passthrough"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.e5914fad5a8d2a2eaaed1091866f9587.svg";
export { ForwardRef as ReactComponent };